<template>
    <v-layout column>
        <v-flex>
            <the-dashboard-pane />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { TheDashboardPane } from '../../organisms';

@Component({
    name: 'TheHomePage',
    components: {
        TheDashboardPane,
    },
})
export default class TheHomePage extends Vue {}
</script>
